import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { LoginContainer } from 'src/containers/auth/login';
import { z } from 'zod';

const loginSearchSchema = z.object({
  returnUrl: z.string().catch('/'),
});

export const Route = createFileRoute('/(common)/login')({
  component: LoginContainer,
  validateSearch: zodValidator(loginSearchSchema),
});
